import {setExamData} from "../../../store/fullLengthExam";

export const clearExamDataForcefully = (storeDispatch) => {
    storeDispatch(setExamData(null));
}